import * as React from 'react'
import { SelectWithLabel } from '../../../Form'
import { getStaticImage } from 'utils/statics'
import { lang } from 'utils/helpers'
import { IMAGE_FORMATS } from 'constants/unsupportedFileFormats'
import usePluginResources from './usePluginResources'
import CollapsablePlugin from 'components/common/CollapsablePlugin'
import { MenuDotsOptions } from 'components/common'
import Nixi1Spinner from 'components/Nixi1Spinner'
import './styles.scss'

const PluginResources = ({ resourceType, isRemoveByUser }) => {
  const isSharedFiles = resourceType === 'sharedFiles'
  const { resources, isOpen, fileFields, filterSelect,
    fileSort, sortSelect, searchParam, fileEditMode,
    fileEditNewName, isOpenMenuOptions, handleRedirect,
    isLoading, setFileEditNewName, toggleCard, setFilterSelect,
    setSortSelect, searchWithParams, searchQuery, selectFile,
    handleChangeFileName, onToggleDotsOptions, handleOpenFile,
    selectedResources, onSelectResource, getMenuOptions,
  } = usePluginResources(resourceType)

  return (
    <CollapsablePlugin
      isOpen={isOpen}
      onClickCollapse={toggleCard}
      disabled={isRemoveByUser}
      title={isSharedFiles
        ? resources.length > 0 ? `${lang('shared_files_plugin_title')} (${resources.length})` : lang('shared_files_plugin_title')
        : lang('dashboard_resources')
      }
      icon={isSharedFiles ? "icon-file-dark" : "icon-book-open-dark"}
      redirectComponent={!isSharedFiles && (
        <button
          className='plugin-resources__redirect-icon-btn'
          title={lang('dashboard_go-resource-management')}
          onClick={() => handleRedirect('/dashboard/configurations/resources')}
        >
          <figure>
            <img src={getStaticImage('/icons/orange-brand/external-link-primary.svg')} alt='Resource management' />
          </figure>
        </button>
      )}
      filterComponent={(
        <div className='plugin-resources__filters'>
          <SelectWithLabel
            name='field'
            key='field'
            classNameWrapper='select-type'
            options={fileFields || []}
            value={fileFields?.find(element => element.value === filterSelect)}
            onChange={(item)=> {
              setFilterSelect(item.value)
              if (item.value !== '' && sortSelect === '') {
                setSortSelect('desc')
              }
              searchWithParams(item.value, sortSelect)
            }}
            isClearable
          />
          <SelectWithLabel
            isClearable
            name='sort'
            key='sort'
            classNameWrapper='select-sort'
            placeholder={lang('dashboard_order-by')}
            options={fileSort || []}
            value={fileSort?.find(element => element.value === sortSelect) || ''}
            onChange={item => {
              if (item) {
                setSortSelect(item.value)
                searchWithParams(filterSelect, item.value)
              } else {
                setSortSelect('')
                searchWithParams(filterSelect, '')
              }
            }}
          />
        </div>
      )}
      searchComponent={(
        <div className='plugin-resources__search'>
          <input 
            type="text"
            className='plugin-resources__search--input'
            value={searchParam}
            onChange={({ target: { value } }) => searchQuery(value)}
            placeholder={lang("dashboard_search")}
          />
          <i className="fa fa-search plugin-resources__search--input-icon"></i>
        </div>
      )}
    >
      <div className='plugin-resources__container'>
        <div className='plugin-resources__separator'></div>
        {
          isLoading ? (
            <div className="plugin-resources__loading">
              <Nixi1Spinner width='15px' height='15px' />
            </div>
          ) : resources && resources.map((file, index) => (
            <div key={`file ${index}`} className='plugin-resources__file-container'>
              <div className='name-container'>
                <input 
                  type='checkbox'
                  id={`${file.urlLong}_${index}`}
                  checked={selectedResources.includes(file.urlLong)}
                  onChange={() => onSelectResource(file.urlLong)} 
                  className='checkbox-to-radio'
                />
                <label className='checkbox-to-radio__label' htmlFor={`${file.urlLong}_${index}`}></label>
                <div className='icon-container'>
                  <div title={lang("dashboard_open_file")} className='icon' onClick={() => handleOpenFile(file.urlLong)}>
                    {file.mimeType === 'image' && !IMAGE_FORMATS.includes((file?.mimeSubtype || '')) ?
                      <img 
                        src={file.urlLong} 
                        alt='imagePreview'
                        onError={({ currentTarget }) => {
                          currentTarget.onerror = null
                          currentTarget.src = getStaticImage('/icons/orange-brand/icon-document.svg')
                        }}
                      /> :
                      <i className={'fa fa-file-o'} />
                    }
                  </div>
                </div>
                {(isSharedFiles && index === fileEditMode) ?
                  <input
                    className='file-title-edit'
                    value={fileEditNewName}
                    onChange={({ target: { value } }) => setFileEditNewName(value)}
                    onBlur={() => handleChangeFileName(file)}
                    onKeyDown={({ key }) => {
                      if (key === 'Enter') {
                        handleChangeFileName(file)
                      }
                    }}
                  /> :
                  <div title={lang("dashboard_attach_file_to_conversation")} className='file-title' onClick={() => selectFile(file)}>{file.name}</div>
                }
              </div>
              <div className='edit-icon-container'>
                {fileEditMode === index ? <i className={'fa fa-check'} onClick={() => handleChangeFileName(file)} /> :
                  <MenuDotsOptions
                    typeOptions={'dotsOptions'}
                    isOpen={isOpenMenuOptions}
                    options={getMenuOptions(index)}
                    id={`${resourceType}_${file._id}_${index}`}
                    toggleDotsOptions={(e) => onToggleDotsOptions(e, `${resourceType}_${file._id}_${index}`)}
                  />
                }
              </div>
            </div>
          ))}
      </div>
    </CollapsablePlugin>
  )
}

export default PluginResources